import React, { Component } from 'react';
import autobind from 'autobind-decorator'
import { jsonResponseHandler } from '../utils/FetchHelper'
import SidebarUI from "../components/sidebarSetting/SidebarUI";
import SidebarSettingForm from '../components/sidebarSetting/SidebarSettingForm';

import { connect } from 'react-redux'
import { initSidebar } from '../actions/sidebar'
import LoadingBox from "../components/common/LoadingBox";
import SidebarPopupLayer from "../components/sidebarSetting/SidebarPopupLayer";
import LoadErrorBox from "../components/common/LoadErrorBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import {addPrefix} from "../utils/UriUtil";

@connect(state => ({
}), dispatch => ({
  initSidebarData: (data) => {
    dispatch(initSidebar(data))
  },
  dispatch
}))
class SidebarApp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      initialized : InitStatus.INIT_READY,
      initialData: null,
    };
  }

  componentDidMount() {
    this.init();
  }

  @autobind
  init() {
    const { dispatch } = this.props;

    this.setState({
      initialized: InitStatus.INIT_DOING,
    });

    fetch(addPrefix("/manage/design/sidebar.json"), {
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(res => res.json())
      .then(data => {
        this.setData(data);
        this.setState({
          initialized: InitStatus.INIT_SUCCESS,
        });
      })
      .catch(e => {
        console.error(e);
        this.setState({
          initialized : InitStatus.INIT_FAIL,
        })
      })

  }

  setData(data) {

    const { initSidebarData } = this.props;

    initSidebarData(data.sidebar);
    this.setState({
      initialData:data.sidebar,
      optionList : data.setting.optionList,
      selected : data.setting.selected,
    })
  }

  @autobind
  savedData(data) {

    const { initSidebarData } = this.props;

    initSidebarData(data);
    this.setState({
      initialData: data,
    });

  }

  @autobind
  rollback() {

    if(confirm('사이드바 설정을 초기화하면 변경된 내용이 저장되지 않습니다.\n초기화 하시겠습니까?')) {
      const {initSidebarData} = this.props;
      const {initialData} = this.state;
      initSidebarData(initialData);
    }
  }

  render() {

    const {initialized, optionList, selected} = this.state;

    return (
      <div className="inner_article decoration_article">
        <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
        { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
        { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
        { (initialized === InitStatus.INIT_SUCCESS ) &&
          <div className="blog_sidebar" id="sidebarSetting-app">
            <h3 className="tit_cont">사이드바</h3>
            <SidebarUI rollback={this.rollback} resetData={this.savedData}/>
            <h3 className="tit_cont">사이드바 설정</h3>
            <SidebarSettingForm optionList={optionList} selected={selected}/>
          </div>
        }
        <SidebarPopupLayer />
      </div>
    );
  }
}

export default SidebarApp;
